import * as actionTypes from '../actions/actionTypes';

const initialState = {
    client: null,
    loading: null,
    error: null
};

const reducer = (state = initialState, action) => {
    switch(action.type){
        case actionTypes.CREDITS_LOADING:
            return {
                ...state,
                loading: true,
                error: null,
                client: null
            };
        case actionTypes.CREDITS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error,
                client: null
            };
        case actionTypes.CREDITS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: false,
                client: action.payload
            };
        default:
            return state;
    }
};

export default reducer;